import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { GalleryCtaComponent } from './gallery-cta.component';
import { ImageUrlPipe } from '@frontend/shared';



@NgModule({
  declarations: [
    GalleryCtaComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    ImageUrlPipe,
  ],
  exports: [
    GalleryCtaComponent
  ]
})
export class GalleryCtaModule { }
